import { api } from '@/api'
import { AddNewUnitRes } from '@/modules/add-new-photo/types/newUnitType'
import { ISimpleResponse } from '@/modules/login/types'

const newTsoddService = api.injectEndpoints({
  endpoints: (build) => ({
    addNewPhoto: build.mutation<ISimpleResponse, AddNewUnitRes>({
      query: (body) => ({
        url: '/devices/updatePhotoCameraProperties',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useAddNewPhotoMutation } = newTsoddService
